import * as proj4x from 'proj4'
import {applyMiddleware, createStore, Store} from 'redux'
import {composeWithDevTools} from '@redux-devtools/extension'
import logger from 'redux-logger'
import thunk from 'redux-thunk'
import appConfig from '../reducers/appConfig'
import {rawConfig} from '../reducers/rawConfig'
import {setLanguage} from './components/nls'
import rootReducer from '../reducers/rootReducer'
import {register} from './models'
import {config} from './reducers/config'

const proj4 = (proj4x as any).default
proj4.defs('EPSG:25835', '+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs ')
proj4.defs('EPSG:32635', '+proj=utm +zone=35 +ellps=WGS84 +datum=WGS84 +units=m +no_defs')
proj4.defs('EPSG:32634', '+proj=utm +zone=34 +ellps=WGS84 +datum=WGS84 +units=m +no_defs')
proj4.defs(
  'BGS2005CAD',
  'PROJCS["BGS_2005_Cadastral",GEOGCS["GCS_ETRS_1989",DATUM["D_ETRS_1989",SPHEROID["GRS_1980",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Lambert_Conformal_Conic"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",4725824.3591],PARAMETER["Central_Meridian",25.5],PARAMETER["Standard_Parallel_1",42.0],PARAMETER["Standard_Parallel_2",43.33333333333333],PARAMETER["Latitude_Of_Origin",42.66787568333333],UNIT["Meter",1.0]]'
)
register(proj4)

export class InitConfig {
  constructor() {
    setLanguage(rawConfig.locale)
    for (const key in rawConfig) {
      ;(appConfig as any)[key] = (rawConfig as any)[key]
    }
    config.setConfig(appConfig)
  }

  public configureStore(): Store {
    const isProduction = process.env.NODE_ENV === 'production'
    const isLoggerEnabled = process.env.REDUX_LOGEER === 'true'
    const middlewares: any[] = isProduction ? [thunk] : isLoggerEnabled ? [thunk, logger] : [thunk]

    const store = createStore(rootReducer, appConfig.initState, composeWithDevTools(applyMiddleware(...middlewares)))

    return store
  }
}
